<template>
  <div>
    <div v-bind:class="!record.active ? 'close': ''">
      <div class="record-head">
        <div class="record-left">
          <span>
           <v-icon color="primary" size="18">developer_board</v-icon>
            <b class="text-blue ml-1">Trading Diary</b>
          </span>
          <span class="text-grey">
            |
            <span class="user-name">{{record.user.username}}</span>
            |
            {{openTime}}

          </span>
          <div class="record-body">
            <div>
              Comment for: 
              <b>{{record.data.type}}</b>

            </div>
          </div>
        </div>
      </div>
      <div class="record-right">
        <span  @click="routeUser()" class="hover">
        <Avatar
          v-if="record.user.avatar != null"
          class="timeline-avatar"
          :src="`https://tradeinpool.com/upload/${record.user.avatar}.png`"
          :size="40"
        ></Avatar>
        <Avatar v-else class="timeline-avatar" :username="record.user.username" :size="40"></Avatar>
        </span>
        <div class="record-menu">
          <MenuCard :record="record" /> 
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from "vue-avatar";
import MenuCard from "@/components/menuCard";
var moment = require("moment-timezone");
export default {
  components: {
    Avatar,
    MenuCard
  },
  props: ["record"],
  data() {
    return {
      setOpacity: "open",
      type: "",
      symbol: "",
      mainClass: "",
      fromNow: moment
        .tz(this.record.created, this.$store.getters.timezone)
        .fromNow(),
      remain: null //=> '26 years, 9 months, and 4 days'
    };
  },
  methods: {
    routeUser() {
      return this.$router.push({path: "/user/"+this.record.user.username});
    },
    replyName(val) {
      this.$emit("reply_to", val);
    },
    updateTimes() {

    
    }
  },
  filters: {},
  mounted() {
    // updating record time
    this.updateTimes();
    
    setInterval(() => {
      this.updateTimes();
    }, 1000);
  },

  computed: {
    openTime() {
      var value = this.record.created;
      return moment.tz(value, this.$store.getters.timezone).format("HH:mm");
    }
  }
};
</script>

<style scoped>
.sajz {
  font-size: 18px;
  margin-bottom: 3px;
  margin-right: 2px;
}

.down,
.errors {
  color: #e62163;
}

.up,
.successes {
  color: #79c04d;
}

.close {
  opacity: 0.4;
}

.hourglass_empty {
  color: #4dbac0;
}

.record-body {
  color: white;
  width: auto;
  margin-left: 22px;
}
</style>
